/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/5/17 18:21
 * @des 当前环境配置
 */

  // dev  开发环境
  // prod 产品环境（hiyiba服务器）

  // 当前debug服务器代理地址
// const proxyTableTarget = 'http://192.168.1.118:8080'
const proxyTableTarget = 'https://hiyiba.com'

//环境配置
// const env = 'dev'
const env = 'prod'
module.exports = {
  env,
  proxyTableTarget
}



// WEBPACK FOOTER //
// ./src/env.js